/* eslint-env browser, node */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleApplyCredit, setCreditClass, setCreditMonths, setCreditWeight, setTransferFeeValue, resetCredit } from '../../redux/modules/registration';
import Dropdown from '../../components/Dropdown';
import classNumbers from '../../modules/data/class-numbers';
import calculateCredit from '../../modules/calculateCredit';
import precise from '../../modules/precise';
import TextInput from '../../components/TextInput';

class CreditTotal extends Component {
  constructor(props) {
    super(props);
    this.onClassChange = this.onClassChange.bind(this);
    this.onWeightChange = this.onWeightChange.bind(this);
    this.onMonthChange = this.onMonthChange.bind(this);
    this.localToggleApplyCredit = this.localToggleApplyCredit.bind(this);
  }

  onClassChange(event) {
    this.props.setCreditClass(event.target.value);
  }

  onWeightChange(event) {
    this.props.setCreditWeight(event.target.value);
  }

  onMonthChange(event) {
    const months = Number(event.target.value);
    this.props.setCreditMonths(months);
  }

  localToggleApplyCredit() {
    const { pipe, BFfee, applyCredit, creditClass, creditMonths, creditWeight } = this.props;
    let r16 = 0;
    if (pipe) {
      r16 = Number(pipe.r16);
    }

    // if applycredit is already checked, just uncheck it
    if (applyCredit) {
      this.props.resetCredit();
      return;
    }

    // now let's do some validation before passing the
    // data along to the reducer.
    if (!creditClass || Number(creditClass) === 0) {
      alert('You must select a credit class to calculate credit.');
      return;
    }
    if (!creditWeight) {
      alert('You must enter a weight or length to calculate credit.');
      return;
    }
    if (!creditMonths) {
      alert('You must chose a credit month 1-27 to calculate credit.');
      return;
    }

    // now let's see if credit is even allowed.
    let creditAllowed = false;
    const creditTotal = calculateCredit({
      tCreditMonths: creditMonths,
      tCreditWeight: creditWeight,
      creditClass,
    });

    if (creditTotal !== Number.MIN_SAFE_INTEGER) {
      creditAllowed = true;
    }

    if (creditAllowed) {
      if (r16 === 5) {
        this.props.setTransferFeeValue(2.50 + BFfee);
      } else {
        this.props.setTransferFeeValue(4.10 + BFfee);
      }
      this.props.toggleApplyCredit(true, precise(creditTotal));
    } else {
      this.props.toggleApplyCredit(false, precise(0));
    }
  }

  getCreditMonths() {
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];
    return months.map((item) => {
      return [`${item}`, item];
    });
  }

  render() {
    const { applyCredit, creditTotal, creditClass, creditMonths, creditWeight } = this.props;

    return (
      <div className="Row Registration-creditRow">
        <TextInput tabIndex="-1" className="Row-total" id="Rsubcredit" tooltip="Total credit calculated" value={applyCredit ? creditTotal : '0.00'} readOnly />
        <input className="no-print" type="checkbox" checked={applyCredit} id="applyCredit" onChange={() => this.localToggleApplyCredit()} />
        <label className="no-print" htmlFor="applyCredit">Apply Credit</label>
        <b className="print-label print-only">Applied Credit</b>

        <Dropdown
          initial={['Class', '0']}
          id="CreditClassCombo"
          tooltip="Choose the credit class"
          options={classNumbers}
          onChange={e => this.onClassChange(e)}
          selectedValue={creditClass}
          className="Dropdown Credit-dropdown no-print"
        />

        <input className="Credit-input no-print" id="tCreditWeight" data-tooltip="" type="number" value={creditWeight || ''} onChange={e => this.onWeightChange(e)} placeholder="lbs / ft" />

        <Dropdown
          initial={['Month', '']}
          id="tCreditMonths"
          tooltip="Choose the credit months 1-27"
          options={this.getCreditMonths()}
          onChange={e => this.onMonthChange(e)}
          selectedValue={creditMonths || ''}
          className="Dropdown Credit-dropdown no-print"
        />

        <button className="no-print Row-resetBtn" onClick={this.props.resetCredit}><i className="fa fa-refresh" aria-hidden="true" /></button>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    creditClass: state.registration.creditClass,
    creditWeight: state.registration.creditWeight,
    creditMonths: state.registration.creditMonths,
    applyCredit: state.registration.applyCredit,
    creditTotal: state.registration.creditTotal,
    pipe: state.registration.pipe,
    BFfee: state.registration.BFfee,
  };
};

export default connect(mapStateToProps, { toggleApplyCredit, setCreditClass, setCreditMonths, setCreditWeight, setTransferFeeValue, resetCredit })(CreditTotal);
